import { render, staticRenderFns } from "./awardDetail.vue?vue&type=template&id=4d73525b&scoped=true&"
import script from "./awardDetail.vue?vue&type=script&lang=js&"
export * from "./awardDetail.vue?vue&type=script&lang=js&"
import style0 from "./awardDetail.vue?vue&type=style&index=0&id=4d73525b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d73525b",
  null
  
)

export default component.exports